export const ADMIN_BOOKING_DETAILS_START = 'ADMIN_BOOKING_DETAILS_START';
export const ADMIN_BOOKING_DETAILS_SUCCESS = 'ADMIN_BOOKING_DETAILS_SUCCESS';
export const ADMIN_BOOKING_DETAILS_ERROR = 'ADMIN_BOOKING_DETAILS_ERROR'

export const ADMIN_CANCEL_BOOKING_DETAILS_START = 'ADMIN_CANCEL_BOOKING_DETAILS_START';
export const ADMIN_CANCEL_BOOKING_DETAILS_SUCCESS = 'ADMIN_CANCEL_BOOKING_DETAILS_SUCCESS';
export const ADMIN_CANCEL_BOOKING_DETAILS_ERROR = 'ADMIN_CANCEL_BOOKING_DETAILS_ERROR'


export const ADMIN_CANCEL_BOOKING_START = 'ADMIN_CANCEL_BOOKING_START';
export const ADMIN_CANCEL_BOOKING_SUCCESS = 'ADMIN_CANCEL_BOOKING_SUCCESS';
export const ADMIN_CANCEL_BOOKING_ERROR = 'ADMIN_CANCEL_BOOKING_ERROR'

export const ADMIN_SHARE_DOCUMENT_START = 'ADMIN_SHARE_DOCUMENT_START';
export const ADMIN_SHARE_DOCUMENT_SUCCESS = 'ADMIN_SHARE_DOCUMENT_SUCCESS';
export const ADMIN_SHARE_DOCUMENT_ERROR = 'ADMIN_SHARE_DOCUMENT_ERROR'